<template>
  <div class="content background1">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{$t('label_269')}}</p>
            <div class="chooseBox spaceBetween" style="height: 100px;">
              <div>
                <div class="selectBox">
                  <div>
                    <div class="selectChoose">
                      <div class="selectText" style="width:74%">
                        <p>{{$t('label_128')}}</p>
                      </div>
                      <div class="select" style="width:350px">
                        <el-input v-model="searchDataList.name" clearable></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>{{$t('label_567')}}</p>
                    </div>
                    <div class="select" style="width:300px">
                      <el-autocomplete style="width:100%" v-model="searchDataList.deptName"
                        :fetch-suggestions="querySearchAsync1" :placeholder="$t('input_14')" :trigger-on-focus="false"
                        @select="handleSelect1" value-key="name" @clear="clearSearch(1)" clearable>
                      </el-autocomplete>
                    </div>
                  </div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>{{$t('label_109')}}</p>
                    </div>
                    <div class="select" style="width:300px">
                      <el-autocomplete style="width:100%" v-model="searchDataList.userName"
                        :fetch-suggestions="querySearchAsync2" :placeholder="$t('input_15')" :trigger-on-focus="false"
                        @select="handleSelect2" value-key="fullName" @clear="clearSearch(2)" clearable>
                      </el-autocomplete>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose"
                    style="display: flex; align-items: center;font-weight: 600;margin-left: 42px;margin-top: 10px">
                    <div class="selectText" style="padding-right: 10px">
                      <p>{{$t('label_216')}}</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-date-picker v-model="Readytime" type="daterange" value-format="yyyy-MM-dd" :range-separator="$t('label_264')"
                        :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" @change="">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search"><i
                      class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
            <div class="spotMes2Box">
              <div class="buttonBox" style=" margin-bottom: 20px;margin-top: 20px;">
                <div style="display: flex;width: 100%">
<!--                  <div class="buttonBox" style="float: left">-->
<!--                    <div>-->
<!--                      <div class="chooseButton searchButton" @click="excel" v-if="MenuRoleList.indexOf('180')>=0">-->
<!--                        <i class="el-icon-download"></i>{{$t('btn_10')}}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div style="display: flex;width: 100%;justify-content: flex-end;">
                    <p class="widthstyle"><img src="../../assets/img/spot/checkNum.png"
                        style="width: 25px; height: 25px;" />
                      {{statisticsup.statusAll}}
                    </p>
                    <p class="widthstyle"><img src="../../assets/img/spot/checkStatus2.png"
                        style="width: 25px; height: 25px;" />
                      {{statisticsup.status2}}
                    </p>
                    <p class="widthstyle" style="color: #FEB406;"><img src="../../assets/img/spot/unUse.png"
                        style="width: 25px; height: 25px; transform: scale(1.2);" />
                       {{statisticsup.status0}}
                    </p>
                    <p class="widthstyle" style="color:#E60000;"><img src="../../assets/img/spot/checkStatus4.png"
                        style="width: 25px; height: 25px;" />
                       {{statisticsup.status3}}
                    </p>
                    <p class="widthstyle"><img src="../../assets/img/spot/checkStatus3.png"
                        style="width: 25px; height: 25px;" />
                       {{statisticsup.status4}}
                    </p>
                    <p class="widthstyle" style="color:#E60000;"><img src="../../assets/img/spot/checkAF.png"
                        style="width: 25px; height: 25px; transform: scale(1.2);" />
                       {{statisticsup.abnormalFlag}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="tableMin">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="statisticsListList" highlight-current-row
                  @current-change="handleCurrentChangeTreeTime" border height="500"
                  style="width: 100%;margin:10px 0 10px 0;"
                  :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex"
                    width="50">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_128')" align="center" width="200">
                  </el-table-column>
                  <el-table-column prop="planAll" :label="$t('label_271')" align="center">
                  </el-table-column>
                  <el-table-column prop="plan2" :label="$t('label_273')" align="center">
                  </el-table-column>
                  <el-table-column prop="plan0" :label="$t('label_276')" align="center">
                  </el-table-column>
                  <el-table-column prop="plan3" :label="$t('label_279')" align="center">
                   <!-- <template slot-scope="scope">
                      <span class="ceshi">{{scope.row.status}}</span>
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="plan4" :label="$t('label_281')" align="center">
                  </el-table-column>
                  <el-table-column prop="af" :label="$t('label_284')" align="center">
                  </el-table-column>
                </el-table>
                <div style="position: absolute;bottom: 30px;left: 30%">
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
                    :currentspage="1" @parentMethod="searchPage"></Page>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "@/assets/css/map/map.css"
  import "@/assets/css/common/spot.css"
  import Page from "@/components/common/page";
  import utils from '@/utils/utils'
  import tree from "@/components/list/tree/checkTree";
  import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
  import file from "@/assets/js/file/file.js";
  import popMesBox from "@/components/list/popover/pop";
  import inspection from "@/assets/js/inspection/inspection.js";
  import exportMes from "@/components/list/export/export";
  export default {
    name: 'InspectionStatistics',
    components: {
      Page,
      tree,
      popMesBox,
      exportMes,
      utils,
      file,
    },
    data() {
      return {
        searchDataList:{
          userName:'',
          deptName:'',
          beginTime:'',
          endTime:'',
		  name: ''
        },
        statusNumList: [],
        value: '0', // 部门默认
        optionspersonnelvalue: '0', // 人员默认
        statisticsListList:[],
        statisticsup:[],
        pageNum: 1,
        pageSize: 10,
        pageCount: 0,
        Readytime: '',
        code: '',
        getTreeMes: '1',
        img: '',
        checked: false,
        dialogImg: false,
        dialogVideo: false,
        dialogSpotRemark: false,
        deviceDetailMes: {},
        dialogSpotResult: false,
        MenuRoleList: [],
        newType: {
          id: '',
          remark: ''
        },
        tableDataTree: [],
        tableDataTreeInfo: [],
        tableDataInfo: [],
        typeName: '',
        deptName: '',

        treeData: {
          dataDevice: [],
          searchShow: true,
          statusShow: false,
          statusListShow: true,
          cardShow: true,
          dataAll: true,
          funtoGetMes: '2'
        },
        treeData2: {
          dataDevice: [],
          searchShow: true,
          statusShow: false,
          statusListShow: true,
          cardShow: true,
          dataAll: true,
          funtoGetMes: '3'
        },
        checkList: [],
        weekendMesOptions: [this.$t('label_716'), this.$t('label_719'), this.$t('label_721'), this.$t('label_723'), this.$t('label_725'), this.$t('label_728'), this.$t('label_730')],
        monthDOptions: [],
        monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
        monthOptionsObj: {
          // this.$t('label_245'): ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
          // this.$t('label_242'): ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
          // this.$t('label_238'): ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        },
        // tableDataTreeTime: [{
        //   status: "1"
        // }, {
        //   status: "1"
        // }],

        statusText: [{
            id: '0',
            text: '启用',
            color: '#3fb393'
          },
          {
            id: '1',
            text: '停用',
            color: '#fe0000'
          },
          {
            id: '2',
            text: '未启用',
            color: '#ffb400'
          },
          {
            id: '3',
            text: '无计划',
            color: '#000000'
          },
        ],
        activeNameTree: 'first',
        status: '',

        styleObject1: {
          width: '0%'
        },
        styleObject2: {
          width: '100%',
          background: '#3fb393'
        },
        styleObject3: {
          width: '0%'
        },
        styleObject4: {
          'width': '0%',
          'text-align': 'right',
          'margin-right': '10px',
          'padding-left': '0%',
          'min-width': '150px'
        },
        styleObject5: {
          'padding-right': '0%',
          'min-width': '150px'
        },
        styleObject6: {
          'width': '0%',
          'text-align': 'right',
          'margin-right': '10px',
          'padding-right': '0%',
          'min-width': '150px'
        },
        styleObject7: {
          'padding-right': '0%',
          'min-width': '150px'
        },
        options: [{ // 部门
          value: '全部',
          id: '0'
        }, {
          value: '测试部门1',
          id: '1'
        }],
        optionspersonnel: [{
          value: '测试部门',
          id: '0'
        }],
        dateValue: [],
        changeid: '',
		id: ''
      }
    },
    methods: {
	  excel() {
		  console.log(this.id);
		  if (this.id != '' && this.id != null) {
		  	window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentInspectionRecord/statisticsExcle?beginTime=' + this.Readytime[0] + "&endTime=" + this.Readytime[1] + "&id=" + this.id;
		  } else {
		  	utils.messageAlert(this.$t('请选择要导出的设备'), this.$t('label_358'), this.$t('label_100'));
		  }
	  },
      changestyle(id) {
        this.changeid = id
      },
      searchStauts(param) {
        SpotCheck.getCheckStatus2(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.statusNumList = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      //获取时间的默认值
      getDate() {
        let start = this.Fungetdate(-7) // 7天前
        let end = this.Fungetdate(0) // 当前时间
        this.dateValue.push(start, end)
        this.Readytime = this.dateValue
      },
      //  当前时间
      Fungetdate(num) {
        var sdd = new Date();
        sdd.setDate(sdd.getDate() + num);
        var yyyy = sdd.getFullYear();
        // var MM = sdd.getMonth() + 1;//获取当前月份的日期
        let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
        var dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
        return yyyy + "-" + MM + "-" + dd;
      },
      selechange() {},
      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      show(id, type) {
        this.img = id;
        if (type == "video") {
          this.dialogVideo = true;
        } else if (type == "photo") {
          this.dialogImg = true;
        }
      },
      closeImg() {
        this.dialogImg = false;
        this.dialogVideo = false;
      },
      checkDefaultValue(value) {},
      checkText(type) {},
      saveRemark() {},
      newTypeSave() {},
      handleClose() {
        this.dialogSpotResult = false;
        this.dialogSpotRemark = false;
      },
      checkResults() {
        this.dialogSpotResult = true
      },
      handleClickTree(tab, event) {
        this.getTreeMes = '1';
        this.deviceDetailMes = {};
        this.search({
          pageNum: 1,
          pageSize: this.pageSize,
        });
      },
      statistics(param) {
      	inspection.statistics(param).then((response) => {
      		const data = response.data;
      		if (data.code == "1") {
      			this.statisticsup = data.data
      		}
      	}).catch((response) => {
      		console.log(response)
      	})
      },
      statisticsList(param) {
      	inspection.statisticsList(param).then((response) => {
      		const data = response.data;
      		if (data.code == "1") {
      			this.statisticsListList = data.data.records
            this.pageCount = data.data.total;
      		}
      	}).catch((response) => {
      		console.log(response)
      	})
      },

      handleSelect1(item) {
        this.searchDataList.deptName = item.name
        this.searchDataList.deptId = item.id
      },
      handleSelect2(item) {
        this.searchDataList.userName = item.fullName
        this.searchDataList.userId = item.id
      },
      querySearchAsync1(queryString, cb) {
        let param = {
          name: this.searchDataList.deptName
        }
        file.selectDept(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      querySearchAsync2(queryString, cb) {
        file.selectUser(this.searchDataList.userName).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      handleCurrentChangeTree(info) {
        this.tableDataTreeInfo = info;
      },
      handleCurrentChangeTreeTime(info) {
        this.tableDataInfo = info;
		this.id = this.tableDataInfo.id;
      },
      changeSelectMonth() {
        this.tableDataTreeEdit.monthD = '';
        for (const k in this.monthOptions) {
          if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
            this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
          }
        }
      },
      search() {
 //0不跨天；1跨天

        		this.searchDataList.beginTime = this.Readytime[0] + ' 00:00:00';
        	//结束时间
        		// this.searchDataList.endTime = this.Readytime[1] + ' 23:59:59';
            this.searchDataList.endTime = this.Readytime[1] +' 23:59:59' ;

        let param = {
        	pageNum: 1,
        	pageSize: this.pageSize,
        }
        this.searchPage(param)
      },
     searchPage(param) {
     	var dataParam = this.searchDataList;
     	var newParam = Object.assign(param, dataParam);
      console.log(newParam)

      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      // this.$refs['pageModel'].setCurrent(this.pageNum);
     	this.statistics(newParam);
     	this.statisticsList(newParam);


     },
     //最后一天
     getday(val){
     var nextMonthFirstDay=new Date(val.substring(0,4),val.substring(5,7),1);
     var oneDay=1000*60*60*24;
     var lastTime = new Date(nextMonthFirstDay-oneDay);
     var day = lastTime.getDate();
     var month = parseInt(lastTime.getMonth()+1);
     if (month < 10) {
     month = '0' + month
     }
     if (day < 10) {
     day = '0' + day
     }
     return lastTime.getFullYear() + '-' + month + '-' + day+ ' ' ;
     },

      //初始化时间
    initDate(){
				var date = new Date();
				var seperator = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
        //开始时间
				var beginTime = year + seperator + this.zero(month)+ seperator + '01';
        //结束时间
        var endTime = this.getday(year + seperator + this.zero(month)+ seperator + this.zero(day));
        this.Readytime = [beginTime,endTime];
        this.search();
			},
      //补0
      zero(i){
      	return i > 9 ? i : '0' + i;
      },
    },
    created() {


      // this.search();
      //调用初始化时间（方法）
      this.initDate();
      this.MenuRoleList = this.$store.getters.getMenu;
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);

    }
  }

</script>

<style>
  .buttonBox .chooseButton {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      -webkit-transition: .1s;
      transition: .1s;
      font-weight: 500;
      padding: 10px 20px;
      font-size: 14px;
      border-radius: 4px;
      margin-left: 0px;
  }

  .ceshi:hover {
    text-decoration: underline;
    color: #f00;
    cursor: pointer;
  }

  .widthstyle {
    width: 14%;
    font-weight: bold;
    font-size: 28px;
  }

  .type_style {
    font-weight: bold;
    color: #4BB699;
    font-size: 10px;
  }

  .down_box {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    border-top: 1px #CACACA solid;
    margin-top: 20px;
  }

  .title_style {
    font-weight: 600;
    margin-right: 80px;
  }

  .number_one {
    font-size: 30px;
    color: #1159C2;
    margin-left: 10px;
    margin-right: 10px;
  }

  .number_two {
    font-size: 20px;
    color: #929497;
  }

  .cehsi {
    width: 100%;
    height: 400px;
    display: flex;
  }

  .left_box {
    width: 25%;
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    border: 1px solid #E1E1E1;
  }

  .right_box {
    width: 75%;
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    border: 1px solid #E1E1E1;
    margin-left: 20px;
  }

  .left_title {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #EFEFEF;
    font-weight: 600;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .content_box {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    box-sizing: border-box;
    border: 1px solid #E1E1E1;
  }

  .content_boxs {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    box-sizing: border-box;
    border: 2px solid #93D2C1;
  }

  .equipment_wid {
    width: 130px;
    margin-left: 10px;
  }

  .bjmodel {
    margin-left: 10px;
  }

  .img_box {
    width: 50%;
    height: 100%;
    border: 1px solid #000000;
    margin-left: 30px;
    margin-right: 30px;
  }

  #dialogImg .el-dialog {
    height: 600px;
  }

  #dialogImg .el-dialog__body {
    height: 546px;
    overflow: auto;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/dailyInspection/InspectionStatistics.vue